exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pill {\n  position: absolute;\n  top: 1rem;\n  left: 48%;\n  border-radius: 40px;\n  z-index: 1;\n}\n.pill.success {\n    color: #fff;\n    background: #6ac951;\n}\n.pill.error {\n    color: #fff;\n    background: #e73f47;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-8b030940","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/Pill.vue
// module id = 2332
// module chunks = 0